import type { HelpFile } from '../../types/help'
import { SchemaPoliciesTestIds } from '../../../testids/SchemaPoliciesTestIds'

export const schemaPoliciesHelp: HelpFile = {
  docPage: '/docs/schema/policies',
  texts: {
    [SchemaPoliciesTestIds.schemaPoliciesList]:
      'Schema policies — declarative invariants the substrate evaluates against parties, identities, and attributes. Pair with the violation list to act on drift.',
    [SchemaPoliciesTestIds.btnCreatePolicy]:
      'Author a new policy from a CEL expression or wire a registered native-code producer.',
    [SchemaPoliciesTestIds.colName]: 'Globally unique kebab-case name; used as the violation policy column.',
    [SchemaPoliciesTestIds.colType]: 'DSL evaluates the CEL expression at detection; NATIVE_CODE delegates to a registered Java producer.',
    [SchemaPoliciesTestIds.colSeverity]: 'Drives badge colour and ordering across violation lists.',
    [SchemaPoliciesTestIds.colEnabled]: 'Disabled policies are skipped on the start-of-day sweep but kept for history.',
    [SchemaPoliciesTestIds.colLastReviewed]: 'When an admin last reviewed the policy. Reviews keep the policy out of the overdue triage bucket.',
    [SchemaPoliciesTestIds.colViolations]: 'Open violation count for this policy.',
  },
}
